<template>
  <div v-if="response.message" class="response" :class="response.type">
    <span class="success" v-if="response.type === 'success'"><font-awesome-icon :icon="['fas', 'check']" /></span>
    <span class="error" v-if="response.type === 'error'"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /></span>
    <span v-if="!response.errors.check">{{ _[response.message] || response.message }}</span>
    <span v-else>{{ response.errors.check.join(',') }}</span>
    <span class="close" @click="clearResponse()"><font-awesome-icon :icon="['fas', 'times']" /></span>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  methods: {
    ...mapMutations(['clearResponse'])
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
@import '@/assets/scss/response';
</style>
